"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIToggleGroup = _interopRequireDefault(require("UIComponents/input/UIToggleGroup"));

var ExpandableFilter = function ExpandableFilter(_ref) {
  var children = _ref.children,
      name = _ref.name;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showAll = _useState2[0],
      setShowAll = _useState2[1];

  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIFormControl.default, {
    "aria-label": name + " filter results",
    style: {
      height: showAll || children.size < 5 ? 'auto' : '10rem'
    }
  }, _react.default.createElement(_UIToggleGroup.default, {
    name: name
  }, children.take(showAll ? Infinity : 5))), !showAll && children.size > 5 && _react.default.createElement(_UIButton.default, {
    use: "transparent",
    className: "p-left-0",
    onClick: function onClick() {
      return setShowAll(true);
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.storefront.expandableFilter.expandButtonText"
  })));
};

ExpandableFilter.propTypes = {
  children: _propTypes.default.node.isRequired,
  name: _propTypes.default.string.isRequired
};
var _default = ExpandableFilter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/ExpandableFilter.js
// module id = 730
// module chunks = 209 210 211 212